import { IntegrationProvider } from 'models'

/**
 * The icon of each integration provider, written out rather than derived.
 *
 * Interpolating `mdi:${provider}` worked while the providers were `hubspot`
 * and `salesforce`, and breaks on the first one whose icon is not named after
 * it: SharePoint's is `mdi:microsoft-sharepoint`. A missing icon is not an
 * error anyone sees, it is an empty square in the corner of a card, so the map
 * is explicit and every new provider has to add its line.
 *
 * Used by the card in Integrations and by the document rows that show where a
 * document came from, which is why it lives next to the component instead of
 * inside it.
 */
const PROVIDER_ICONS: Record<IntegrationProvider, string> = {
    [IntegrationProvider.HubSpot]: 'mdi:hubspot',
    [IntegrationProvider.Salesforce]: 'mdi:salesforce',
    [IntegrationProvider.SharePoint]: 'mdi:microsoft-sharepoint',
}

/**
 * Document sources that are not integrations: a web source has no credential
 * and no card in Integrations, but its folder and its panel still say where
 * the pages come from.
 */
const SOURCE_ICONS: Record<string, string> = {
    web: 'ri:global-line',
}

/** Fallback for a provider added to the enum and forgotten here. */
const FALLBACK_ICON = 'mdi:puzzle-outline'

export function integrationProviderIcon(
    provider?: IntegrationProvider | string,
): string {
    if (!provider) {
        return FALLBACK_ICON
    }
    return (
        PROVIDER_ICONS[provider as IntegrationProvider] ??
        SOURCE_ICONS[provider] ??
        FALLBACK_ICON
    )
}
